var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollectionsHeader = function SvgCollectionsHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1280 581"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#collections-header_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__b)",
    d: "M546.941 462.842c34.593-34.59 34.593-90.673 0-125.263-34.592-34.59-90.678-34.59-125.271 0s-34.593 90.673 0 125.263 90.679 34.59 125.271 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__c)",
    d: "M902.145 234.234H222.488v263.348c0 46.061 38.619 83.414 84.735 83.418 46.06 0 84.707-37.353 84.707-83.418v-81.505c0-32.291 27.042-58.494 59.441-58.494 32.347 0 57.794 26.203 57.794 58.494l-1.049 33.261v.837c0 46.143 38.666 83.473 84.707 83.473s84.735-37.33 84.735-83.469v-82.656c0-32.318 26.1-58.521 58.416-58.521s58.373 26.203 58.373 58.521l-.603 44.356v13.047c0 46.065 36.206 83.418 82.317 83.418l26.084-274.106z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__d)",
    d: "M876.061 271.902H222.488V131.665c0-46.062 38.619-83.414 84.735-83.418 46.064 0 84.707 37.353 84.707 83.418v81.505c0 32.29 27.038 58.494 59.441 58.494 32.347 0 57.794-26.204 57.794-58.494l-1.049-33.261v-.837c0-46.144 38.666-83.473 84.707-83.473s84.735 37.329 84.735 83.469v82.655c0 32.318 26.1 58.522 58.416 58.522s58.373-26.204 58.373-58.522l-.603-44.355v-13.047c0-46.066 36.206-83.419 82.317-83.419z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__e)",
    d: "M847.99 569.241c145.563 0 263.57-117.994 263.57-263.548 0-145.553-118.007-263.547-263.57-263.547-145.564 0-263.567 117.994-263.567 263.547S702.426 569.241 847.99 569.241"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__f)",
    d: "M1094.79 0c-34.58 0-63.59 28.038-63.59 62.617V123.8c0 24.24-20.29 43.91-44.614 43.91-24.28 0-43.384-19.67-43.38-43.91l.786-24.967v-.63c0-34.634-29.026-62.656-63.584-62.656S816.8 63.564 816.8 98.202v62.046c0 24.259-19.589 43.929-43.85 43.929s-43.815-19.67-43.815-43.929l.454-33.296v-9.792c0-34.58-27.179-62.617-61.792-62.617s-61.773 28.038-61.773 62.617v65.043c0 24.298-21.131 43.988-45.411 43.988s-45.447-19.69-45.447-43.988v-80.089c0-34.575-27.156-62.613-61.753-62.613s-61.792 28.038-61.792 62.613v24.107c0 24.259-19.989 43.988-44.289 43.991-24.26 0-43.556-19.728-43.556-43.991l.626-6.655V96.645c0-34.575-28.983-62.613-63.565-62.613s-63.623 28.038-63.623 62.613v319.988c0 34.575 28.987 62.613 63.607 62.617 34.578 0 63.585-28.038 63.585-62.617v-61.182c0-24.239 20.297-43.909 44.617-43.909 24.28 0 43.384 19.67 43.38 43.909l-.786 24.967v.63c0 34.634 29.026 62.657 63.584 62.657s63.608-28.019 63.608-62.657v-62.046c0-24.259 19.589-43.929 43.85-43.929s43.815 19.67 43.815 43.929l-.454 33.296v9.792c0 34.579 27.179 62.618 61.792 62.618s61.773-28.039 61.773-62.618v-65.043c0-24.298 21.131-43.988 45.411-43.988s45.447 19.69 45.447 43.988v80.089c0 34.576 27.155 62.614 61.753 62.614s61.792-28.038 61.792-62.614V353.03c0-24.259 19.988-43.988 44.288-43.992 24.264 0 43.554 19.729 43.554 43.988l-.62 6.654v22.921c0 34.576 28.98 62.614 63.56 62.614s63.63-28.038 63.63-62.614V62.617c0-34.579-29-62.617-63.61-62.617"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__g)",
    d: "m423.354 241.326-.145.008.145-51.933v-27.682c0-18.086-14.214-32.749-32.316-32.749s-32.309 14.663-32.309 32.749v56.577c0 12.706-11.052 23.007-23.748 23.007s-23.768-10.297-23.768-23.007v-51.718c0-18.082-14.202-32.749-32.297-32.749S246.6 148.492 246.6 166.578v22.44c0 12.687-10.454 23.007-23.161 23.007s-22.782-10.32-22.782-23.007l.328-26.137V60.399c0-18.082-15.156-32.749-33.243-32.749S134.467 42.313 134.467 60.4v232.133l.145-.008-.145 51.934v27.682c0 18.086 14.214 32.748 32.316 32.748s32.309-14.662 32.309-32.748v-56.577c0-12.707 11.052-23.007 23.748-23.007s23.768 10.296 23.768 23.007v51.718c0 18.082 14.202 32.748 32.297 32.748s32.316-14.662 32.316-32.748v-22.44c0-12.687 10.454-23.007 23.161-23.007s22.782 10.32 22.782 23.007l-.328 26.137v102.486c0 18.082 15.156 32.748 33.243 32.748s33.275-14.662 33.275-32.748V241.326"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M418.816 102.094c-8.459-8.458-8.459-22.17 0-30.632 8.458-8.45 22.171-8.45 30.63 0 8.462 8.462 8.462 22.178-.004 30.632-8.459 8.458-22.172 8.458-30.626 0",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__h)",
    d: "m15.432 164.877 7.328-7.327 7.328 7.327a9.04 9.04 0 1 0 12.786-12.785l-7.328-7.327 7.328-7.328c3.529-3.532 3.529-9.256 0-12.784a9.037 9.037 0 0 0-12.786 0l-7.328 7.327-7.328-7.327c-3.533-3.533-9.256-3.533-12.785 0-3.53 3.528-3.53 9.256 0 12.784l7.328 7.328-7.328 7.327c-3.53 3.533-3.53 9.256 0 12.785s9.256 3.533 12.785 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__i)",
    d: "m1204.58 323.156 4.93-4.937 4.95 4.937a6.087 6.087 0 0 0 8.61 0 6.095 6.095 0 0 0 0-8.619l-4.93-4.937 4.93-4.941a6.093 6.093 0 0 0 0-8.618 6.086 6.086 0 0 0-8.61 0l-4.95 4.941-4.93-4.941a6.093 6.093 0 1 0-8.62 8.618l4.94 4.941-4.94 4.937a6.095 6.095 0 1 0 8.62 8.619"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__j)",
    d: "M952.29 553.071c-3.623-3.622-3.623-9.498 0-13.125 3.623-3.619 9.499-3.619 13.122 0 3.627 3.627 3.627 9.503 0 13.125a9.28 9.28 0 0 1-13.122 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__k)",
    d: "M1277.21 77.1c3.72 3.721 3.72 9.762 0 13.486-3.72 3.72-9.76 3.72-13.49 0-3.72-3.724-3.72-9.76 0-13.485a9.54 9.54 0 0 1 13.49 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M858.596 418.228c0-12.272 9.957-22.232 22.23-22.232 12.27.008 22.223 9.952 22.227 22.221 0 12.276-9.953 22.236-22.234 22.228-12.274-.007-22.223-9.952-22.223-22.22",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__l)",
    d: "M232.406 561.845h-.008a15.23 15.23 0 0 1-10.841-4.491 15.23 15.23 0 0 1-4.492-10.841c0-8.454 6.878-15.331 15.333-15.335 8.451 0 15.329 6.881 15.333 15.331 0 8.454-6.878 15.332-15.329 15.332zm0-29.099c-7.594 0-13.768 6.178-13.768 13.771 0 3.678 1.432 7.132 4.034 9.733a13.67 13.67 0 0 0 9.734 4.034h.008c7.59 0 13.764-6.177 13.764-13.767-.004-7.589-6.182-13.763-13.768-13.767z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__m)",
    d: "M417.388 410.024H205.317c-10.462 0-18.976-8.513-18.976-18.974V246.153c0-10.461 8.514-18.974 18.976-18.974h75.094v1.174h-75.094c-9.817 0-17.802 7.985-17.802 17.8V391.05c0 9.816 7.985 17.8 17.802 17.8h212.071z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__n)",
    d: "m262.273 459.544-11.764-22.925 1.044-.536 11.229 21.88 66.104-33.918-33.917-66.099-66.108 33.914 17.774 34.638-1.044.536-18.306-35.678.52-.27 67.673-34.72 34.988 68.188-.52.27z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "m119.168 326.455-6.272 16.236 16.237 6.271 6.272-16.236z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__o)",
    d: "M218.517 482.637a15.9 15.9 0 0 1-4.179-.564l-.469.098-.188-.305c-3.509-1.158-5.438-4.291-7.48-7.609l-.583-.947c-2.492-4.002-3.361-7.977-3.349-10.371-.063-.735-.231-3.039-.024-3.72.223-.728.38-2.629.407-4.969-.023-.465.09-1.189.211-1.956.09-.567.18-1.15.18-1.455v-.078l.02-.074c1.15-4.261 3.728-11.752 5.082-15.473.524-1.432.474-2.824.431-3.939-.012-.345-.024-.669-.02-.971.016-.954.035-1.944.485-2.812.669-1.303 2.179-2.05 4.143-2.05.603 0 1.229.074 1.816.215.356.09.665.184.946.293 1.006.384 1.867 1.323 2.555 2.782 1.233 2.59 2.011 7.175 1.025 10.559a86 86 0 0 0-.763 2.816c3.138-1.921 8.169-4.984 9.015-5.398l20.637-11.964a6.07 6.07 0 0 1 3.205-.911 6.09 6.09 0 0 1 5.195 2.883l.165.262a4.92 4.92 0 0 1 .618 3.728 4.9 4.9 0 0 1-2.199 3.071l-16.855 10.489a6.3 6.3 0 0 1 3.044 2.237c1.413 1.898 1.671 4.003.744 5.861.997.548 2.151 1.553 2.903 3.407.692 1.71.434 3.423-.72 4.887 1.072.829 1.78 1.924 2.054 3.188.704 3.255-2.246 5.379-3.165 5.95l-17.054 10.614a14.84 14.84 0 0 1-7.837 2.222zm-4.065-1.749.063.016c1.318.371 2.664.559 4.002.559 2.57 0 5.066-.708 7.214-2.046l17.054-10.613c.756-.47 3.181-2.199 2.637-4.707-.238-1.083-.856-1.983-1.842-2.668l-.086-.058-.529-.744.333-.352c1.139-1.213 1.432-2.617.849-4.061-.755-1.862-1.972-2.683-2.86-3.047l-.657-.27.387-.595c1.045-1.604.92-3.364-.372-5.097-.888-1.186-2.128-1.898-3.689-2.117l-1.604-.223 19.421-12.084a3.75 3.75 0 0 0 1.678-2.344 3.75 3.75 0 0 0-.469-2.84l-.164-.262a4.92 4.92 0 0 0-4.198-2.332c-.92 0-1.816.259-2.598.744l-20.771 12.026c-.473.207-6.448 3.837-10.098 6.079l-1.213.747.337-1.385c.395-1.619.774-3.051 1.123-4.252.903-3.106.18-7.331-.959-9.73-.548-1.161-1.209-1.916-1.913-2.186a7 7 0 0 0-.802-.251 6.8 6.8 0 0 0-1.534-.18c-.712 0-2.445.137-3.102 1.416-.325.626-.341 1.44-.356 2.297-.004.266.007.575.019.904.043 1.154.102 2.738-.501 4.385-1.338 3.681-3.881 11.071-5.035 15.308-.012.395-.102.959-.196 1.553-.101.65-.219 1.389-.195 1.722v.047c-.012 1.197-.086 4.107-.458 5.32-.098.325-.039 1.968.071 3.306v.055c-.02 2.124.802 5.958 3.172 9.768q.3.481.587.951c2.047 3.325 3.815 6.2 7.035 7.167z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M97.475 434.802h44.934"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m140.699 440.653 10.134-5.853-10.134-5.849z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__p)",
    d: "M1157.51 46.59c-11.97 0-22 9.706-22 21.677v28.72l.22 17.299c0 8.399-6.69 15.23-15.08 15.23-8.41 0-15.33-6.831-15.33-15.23v-7.03c0-11.972-9.42-21.678-21.4-21.678s-21.37 9.706-21.37 21.678v26.41c0 8.411-7.33 15.23-15.74 15.23s-15.72-6.819-15.72-15.23V84.479c0-11.971-9.41-21.677-21.39-21.677-11.975 0-21.388 9.706-21.388 21.677v30.061l.156 11.525c0 8.399-6.749 15.21-15.168 15.21s-15.18-6.811-15.18-15.21v-15.863c0-11.991-10.036-21.693-22.019-21.693-11.984 0-22.015 9.702-22.015 21.693v.219l.246 69.182h-.246v118.564c0 11.971 10.035 21.677 22.026 21.677 11.992 0 22.008-9.706 22.008-21.677v-28.719l-.22-17.299c0-8.399 6.683-15.23 15.079-15.23s15.333 6.831 15.333 15.23v7.03c0 11.971 9.413 21.677 21.388 21.677 11.98 0 21.38-9.706 21.38-21.677v-26.411c0-8.411 7.33-15.23 15.74-15.23s15.72 6.815 15.72 15.23v49.187c0 11.971 9.41 21.677 21.38 21.677 11.98 0 21.4-9.706 21.4-21.677v-30.06l-.16-11.529c0-8.4 6.75-15.211 15.17-15.211s15.18 6.811 15.18 15.211v15.863c0 11.991 10.03 21.693 22.02 21.693 11.98 0 22.01-9.702 22.01-21.693v-.219l-.25-69.182h.25V68.268c0-11.972-10.03-21.678-22.03-21.678"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__q)",
    d: "M1262.56 494.308c10.13-10.128 10.13-26.543 0-36.672l-48.71-48.706a3.32 3.32 0 0 0-4.7 0 3.323 3.323 0 0 0 0 4.703l15.6 15.601 1 1.002 1.28 1.279c.92.911.92 2.39 0 3.302-.91.911-2.38.911-3.29 0l-1.17-1.186-22.81-22.807a3.32 3.32 0 0 0-4.7 0 3.32 3.32 0 0 0 0 4.702l24.55 24.545.8.802c.92.911.92 2.39 0 3.301a2.32 2.32 0 0 1-3.29 0l-1.24-1.259-30.37-30.366a3.32 3.32 0 0 0-4.7 0 3.32 3.32 0 0 0 0 4.702l30.36 30.366 2.09 2.066a2.333 2.333 0 0 1-3.3 3.298l-.57-.564-21.3-21.301a3.333 3.333 0 0 0-4.71 0 3.32 3.32 0 0 0 0 4.702l18.79 18.782.97.978a2.32 2.32 0 0 1 0 3.302c-.91.912-2.39.912-3.3 0l-1.86-1.882-12.73-12.734a3.34 3.34 0 0 0-4.71 0 3.33 3.33 0 0 0 0 4.703l45.34 45.341c10.13 10.125 26.55 10.125 36.68 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1233.43 486.663c-5.93-5.931-5.93-15.547 0-21.478 5.94-5.93 15.55-5.93 21.48 0 5.93 5.931 5.93 15.547 0 21.478s-15.54 5.931-21.47 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__r)",
    d: "M1249.44 470.663a7.447 7.447 0 0 0-10.53 0 7.45 7.45 0 0 0 0 10.52 7.45 7.45 0 0 0 10.53 0 7.45 7.45 0 0 0 0-10.52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__s)",
    d: "M1117.87 410.024h-84.66v-1.174h84.66c9.81 0 17.8-7.984 17.8-17.8V246.153c0-9.815-7.99-17.8-17.8-17.8H776.502v-1.174h341.368c10.46 0 18.97 8.513 18.97 18.974V391.05c0 10.461-8.51 18.974-18.97 18.974"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__t)",
    d: "m1068.22 290.868-38.83-13.833.39-1.103 37.73 13.438 32.16-90.253-90.26-32.154-32.159 90.253 42.559 15.163-.39 1.104-43.671-15.559.199-.551 32.752-91.912 92.46 32.944-.19.556z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__u)",
    d: "M1026.3 328.674c-2.62 0-5.2-1.095-7.93-2.257-.34-.145-.68-.29-1.03-.434-4.35-1.823-7.36-4.558-8.73-6.518-.47-.563-1.95-2.343-2.17-3.02-.24-.72-1.22-2.363-2.55-4.288-.29-.364-.61-1.021-.95-1.713-.26-.513-.52-1.045-.7-1.291l-.04-.063-.03-.074c-1.53-4.143-3.761-11.745-4.809-15.563-.399-1.471-1.248-2.574-1.929-3.462-.211-.274-.411-.532-.575-.778-.54-.791-1.096-1.604-1.233-2.575-.32-2.218 1.745-4.119 3.795-4.945.345-.133.65-.234.943-.309 1.025-.262 2.288 0 3.688.791 2.51 1.4 5.79 4.686 6.95 8.016.28.813.62 1.729 1.01 2.738 1.45-3.384 3.78-8.794 4.23-9.62l9.9-21.696a6.095 6.095 0 0 1 5.63-3.729c.81 0 1.61.161 2.36.478l.29.121a4.89 4.89 0 0 1 2.66 2.684c.5 1.22.49 2.562-.02 3.779l-7.67 18.308a6.33 6.33 0 0 1 3.78.063c2.25.732 3.68 2.296 4 4.35 1.45-.168 2.93.204 4.34 1.1 1.55.993 2.33 2.542 2.24 4.401 1.35.054 2.56.54 3.52 1.408 2.46 2.25 1.28 5.684.86 6.686l-7.76 18.524c-1.62 3.861-4.76 6.803-8.84 8.305l-.33.352-.33-.141c-.83.259-1.67.38-2.57.38zm-23.05-20.136c.21.329.47.842.73 1.381.3.591.63 1.256.84 1.518l.03.035c.68.986 2.3 3.404 2.7 4.605.1.321 1.11 1.627 1.97 2.652l.03.044c1.22 1.744 4.1 4.393 8.24 6.13.35.145.69.289 1.03.434 2.62 1.115 5.09 2.163 7.48 2.163.84 0 1.63-.129 2.41-.387l.21-.07h.01l.06-.016c3.84-1.373 6.78-4.108 8.29-7.707l7.76-18.524c.35-.821 1.32-3.634-.57-5.363-.81-.736-1.82-1.111-2.99-1.111h-.16l-.86-.301.06-.478c.23-1.647-.34-2.961-1.66-3.802-1.34-.857-2.76-1.139-4.09-.83l-.7.161-.02-.712c-.08-1.913-1.2-3.275-3.25-3.94-1.41-.454-2.84-.313-4.24.411l-1.43.747 8.84-21.098c.39-.927.39-1.948.01-2.879a3.74 3.74 0 0 0-2.03-2.046l-.28-.122a4.9 4.9 0 0 0-1.91-.387c-2 0-3.78 1.189-4.55 3.028l-9.98 21.826c-.27.442-3.04 6.862-4.72 10.801l-.56 1.311-.52-1.326a87 87 0 0 1-1.54-4.12c-1.07-3.055-4.1-6.083-6.42-7.378-1.12-.634-2.09-.865-2.826-.677a7 7 0 0 0-.798.262c-1.686.681-3.286 2.167-3.067 3.689.097.701.555 1.37 1.04 2.078.149.219.337.465.54.727.704.92 1.667 2.175 2.129 3.869 1.036 3.776 3.242 11.271 4.752 15.398z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__v)",
    d: "M967.228 201.166H922.29v1.173h44.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections-header_svg__w)",
    d: "m924.003 195.9-10.133 5.849 10.133 5.853z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M756.416 171.965h-4.843v.047h4.843z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__b",
    x1: 484.305,
    x2: 484.305,
    y1: 345.235,
    y2: 458.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA1C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E1F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__c",
    x1: 562.318,
    x2: 562.318,
    y1: 270.495,
    y2: 537.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15A29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__d",
    x1: 549.275,
    x2: 549.275,
    y1: 291.803,
    y2: 82.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15A29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__e",
    x1: 847.99,
    x2: 847.99,
    y1: 142.12,
    y2: 478.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40BFB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A79D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__f",
    x1: 279.902,
    x2: 1800.15,
    y1: 239.625,
    y2: 239.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA1C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E1F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__g",
    x1: 424.704,
    x2: 76.998,
    y1: 266.927,
    y2: 266.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40BFB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A79D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__h",
    x1: -0.002,
    x2: 45.523,
    y1: 144.761,
    y2: 144.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__i",
    x1: 1209.52,
    x2: 1209.52,
    y1: 295.607,
    y2: 320.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40BFB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A79D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__j",
    x1: 949.575,
    x2: 968.131,
    y1: 546.511,
    y2: 546.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__k",
    x1: 1260.93,
    x2: 1280,
    y1: 83.841,
    y2: 83.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__l",
    x1: 221.551,
    x2: 243.227,
    y1: 557.332,
    y2: 535.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__m",
    x1: 186.341,
    x2: 417.388,
    y1: 318.602,
    y2: 318.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__n",
    x1: 227.285,
    x2: 330.466,
    y1: 407.955,
    y2: 407.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__o",
    x1: 202.144,
    x2: 257.731,
    y1: 453.237,
    y2: 453.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__p",
    x1: 1046.81,
    x2: 1046.81,
    y1: 83.067,
    y2: 323.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15A29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__q",
    x1: 1179.57,
    x2: 1270.16,
    y1: 454.929,
    y2: 454.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA1C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E1F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__r",
    x1: 1244.17,
    x2: 1244.17,
    y1: 465.749,
    y2: 479.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__s",
    x1: 776.498,
    x2: 1136.84,
    y1: 318.602,
    y2: 318.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__t",
    x1: 975.749,
    x2: 1101.16,
    y1: 228.165,
    y2: 228.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__u",
    x1: 993.589,
    x2: 1046.78,
    y1: 293.277,
    y2: 293.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__v",
    x1: 922.29,
    x2: 967.228,
    y1: 201.753,
    y2: 201.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections-header_svg__w",
    x1: 913.87,
    x2: 924.003,
    y1: 201.753,
    y2: 201.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "collections-header_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1280v581H0z"
  })))));
};
export default SvgCollectionsHeader;